import { useEffect, useState } from "react";
import { allowedCharacters } from "../../configs/generated-page-configs";
import LottieData from "../../types/lottie";

const useLottieLoader = (userName: string = "") => {
  const [lottieData, setLottieData] = useState<LottieData[]>([]);

  useEffect(() => {
    userName?.split(" ").forEach((word) => {
      word.split("").forEach((letter) => {
        if (!allowedCharacters.includes(letter.toLowerCase())) {
          return;
        }

        if (lottieData.find((l) => l.letter === letter)) {
          return;
        }

        fetch(`/assets/animated-hieroglyphs/${letter.toLowerCase()}.json`).then(
          (response) => {
            response.json().then((data) => {
              setLottieData((prev) => [...prev, { letter, data }]);
            });
          },
        );
      });
    });
  }, [lottieData, setLottieData, userName]);

  return lottieData;
};

export default useLottieLoader;
